import Component from './component.vue';

export default Component;



// WEBPACK FOOTER //
// ./src/pages/ticket/index.ts